<template>
    <div class="uk-width-1-1">

        <div class="uk-grid-medium uk-child-width-1-1"
             uk-grid>

            <!-- Description -->
            <div v-if="page.ShopPage.description && page.ShopItems.current === 1">

                <div class="uk-card uk-card-body uk-card-default" style="padding-top: 20px;">
                    <article class="uk-article uk-text-small">
                        <div v-if="pageImage" class="uk-flex uk-flex-center uk-flex-middle">
                            <div class="uk-position-relative">
                                <img :src="pageImage.src"
                                     :alt="pageImage.description"
                                 class="step-down-transformer-icon">
                                 <p class="step-down-transformer-first">220</p>
                                 <div class="step-down-transformer-second">
                                     <p>{{ pageImage.title }}</p>
                                 </div>
                             </div>
                        </div>
                        <div v-html="page.ShopPage.description"></div>
                    </article>
                </div>

            </div>

            <div>

                <shop-products @load-page="loadPage"
                               @buy-shop-item="buy"
                               :shop-items="page.ShopItems"
                               :shop-item-prices="page.ShopItemPrices"
                               :shop-items-related="page.ShopItemsRelated"
                               :shop-item-properties="page.ShopItemProperties"
                               :shop-item-warehouses="page.ShopItemWarehouses"
                               :shop-item-tags="page.ShopItemTags"
                               :shop-order-items="page.ShopOrderItems">
                </shop-products>

                <div v-if="page.ShopPage.text" class="uk-grid-medium uk-child-width-1-1" uk-grid>
                    <div>
                        <div class="uk-card uk-card-body uk-card-default">
                            <article v-html="page.ShopPage.text" class="uk-article uk-text-small">
                            </article>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <loading
                :show="loading"
                loader-class="tm-loader-wrapper"
                label="">
            <template slot="loading-spinner">
                <div uk-spinner="ratio: 2"></div>
            </template>
        </loading>
    </div>
</template>

<script>
    import loading from 'vue-full-loading'
    import ShopProductsMixin from './ShopProductsMixin'
    import ShopProducts from "./ShopProducts";

    export default {
        name: "ShopPage",
        mixins: [ShopProductsMixin],
        components: {
            ShopProducts,
            loading
        },
        props: {
            ShopPage: {
                type: Object,
                required: true
            },
            Image: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        created() {
            this.bindHistoryManipulation(location.href, this.params)
        },
        data() {
            return {
                page: {
                    ShopPage: this.ShopPage,
                    ShopItems: this.ShopItems,
                    ShopItemPrices: this.ShopItemPrices,
                    ShopItemsRelated: this.ShopItemsRelated,
                    ShopItemProperties: this.ShopItemProperties,
                    ShopFilterProperties: this.ShopFilterProperties,
                    ShopFilterPropertyValues: this.ShopFilterPropertyValues,
                    ShopItemWarehouses: this.ShopItemWarehouses,
                    ShopItemTags: this.ShopItemTags,
                    ShopOrderItems: this.ShopOrderItems
                },
                params: {
                    page: 1
                }
            }
        },
        computed: {
            pageImage() {
                return this.Image;
            }
        },
        methods: {
            loadPage(page) {
                this.params.page = page;
                this.fetchShopItems(this.page.ShopPage.href, this.params);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ShopSDTransformerPage.vue?591141c8